import { useCallback } from "react"

type HapticType = "success" | "warning" | "error" | "light" | "medium" | "heavy" | "selection"

/**
 * useHaptic
 * 
 * Provides a simple interface for the Vibration API.
 * Safely handles environments where vibration is not supported.
 */
export function useHaptic() {
    const vibrate = useCallback((pattern: number | number[]) => {
        if (typeof window !== "undefined" && navigator.vibrate) {
            navigator.vibrate(pattern)
        }
    }, [])

    const trigger = useCallback((type: HapticType = "light") => {
        switch (type) {
            case "success":
                vibrate([10, 30, 10])
                break
            case "warning":
                vibrate([30, 50, 10])
                break
            case "error":
                vibrate([50, 30, 50, 30, 50])
                break
            case "light":
                vibrate(10)
                break
            case "medium":
                vibrate(20)
                break
            case "heavy":
                vibrate(40)
                break
            case "selection":
                vibrate(5) // Ultra subtle for UI clicks
                break
        }
    }, [vibrate])

    return { trigger }
}
